<template>
  <div class="basket checkout container fluid">
    <div class="basket__nav row">
      <router-link class="basket__nav__back" to="/panier">
        <img src="@/assets/images/ic_back.svg" />
      </router-link>
      <Logo class="basket__nav__logo" color />
    </div>
    <div class="basket-layout">
      <BasketReassurance />
      <div class="row" style="flex: 1">
        <BasketResume :shoe="myShoe" :user="user" class="col-md-5" />
        <div class="basket__content checkout__content col-md-7">
          <CheckoutStripeButton label="Confirmer" />
          <div class="basket__content__title">
            <h2>Choisissez votre formule</h2>

            <!-- ///// Formule 2 ///// -->
            <div
              class="formule --lover row"
              :class="{ '--unavailable': !isFirstOffer }"
            >
              <div class="col-xs-12 col-md-8 pr-md-4">
                <h3>Sneakers Lover</h3>
                <p>Bénéficiez de paires allant de 200€ à 400€</p>
              </div>
              <div class="col-xs-12 col-md-4 mt-xs-3 mt-md-0">
                <div class="formule__price">
                  75€
                  <span>/ mois</span>
                </div>

                <!-- <Button
                  class="formule__button"
                  @click.native="popinIsOpen = !popinIsOpen"
                  :disabled="!isFirstOffer"
                >
                  Payer
                </Button> -->
                <Button
                  class="formule__button"
                  @click.native="openLink(payLinks.lover)"
                  :disabled="!isFirstOffer"
                >
                  Payer
                </Button>
              </div>
              <div class="popin-creditcard" v-show="popinIsOpen">
                <CheckoutCardForm />
              </div>
            </div>

            <!-- ///// Formule 3 ///// -->
            <div
              class="formule --addict row"
              :class="{ '--unavailable': !isSecondOffer }"
            >
              <div class="col-xs-12 col-md-8 pr-md-4">
                <h3>Sneakers Addict</h3>
                <p>Bénéficiez de paires allant de 400€ à 600€</p>
              </div>
              <div class="col-xs-12 col-md-4 mt-xs-3 mt-md-0">
                <div class="formule__price">
                  95€
                  <span>/ mois</span>
                </div>

                <Button
                  class="formule__button"
                  @click.native="openLink(payLinks.addict)"
                  :disabled="!isSecondOffer"
                >
                  Payer
                </Button>
              </div>
            </div>

            <!-- ///// Formule 1 ///// -->
            <div class="formule --free row">
              <div class="col-xs-12 col-md-8 pr-md-4">
                <h3>Invité</h3>
                <p>
                  Tu as été invité ? Entre ton code action pour terminer le
                  processus
                </p>
              </div>
              <div class="col-xs-12 col-md-4 mt-xs-3 mt-md-0">
                <form v-on:submit.prevent="submitCode">
                  <div class="formule__code">
                    <input
                      v-model="code"
                      class="input"
                      type="text"
                      placeholder="Code action"
                      required
                    />
                    <div class="input__error">{{ error }}</div>
                  </div>

                  <Button class="formule__button" type="submit" secondary>
                    Appliquer le code
                  </Button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Logo from "@/components/Common/Logo";
import BasketResume from "@/components/Basket/BasketResume";
import BasketReassurance from "@/components/Basket/BasketReassurance";
import Button from "@/components/Common/Button";
import CheckoutCardForm from "@/components/Checkout/CheckoutCardForm";
import CheckoutStripeButton from "@/components/Checkout/CheckoutStripeButton";

export default {
  name: "Checkout",
  components: {
    Logo,
    BasketResume,
    BasketReassurance,
    Button,
    CheckoutCardForm,
    CheckoutStripeButton
  },
  data() {
    return {
      error: "",
      code: "",
      popinIsOpen: false,
      step1: 40000,
      step2: 60000
    };
  },
  computed: {
    ...mapState({
      shoe: state => state.auth.shoe,
      user: state => state.auth.user
    }),
    ...mapGetters({
      getShoeById: "getShoeById",
      getWinnerByMail: "getWinnerByMail"
    }),
    myShoe() {
      return this.getShoeById(this.shoe);
    },
    isFirstOffer() {
      return this.myShoe.price <= this.step1;
    },
    isSecondOffer() {
      return this.myShoe.price > this.step1 && this.myShoe.price <= this.step2;
    },
    isThirdOffer() {
      return this.myShoe.price > this.step2;
    },
    payLinks() {
      return this.user.payLinks;
    }
  },
  methods: {
    submitCode() {
      const r = this.getWinnerByMail(this.user.mail);
      if (r !== undefined) {
        if (r.code === this.code.toUpperCase()) {
          this.error = "";
          this.$router.push("/validation");
        } else {
          this.error = "Mauvais code action";
        }
      } else {
        this.error = "Vous ne faites pas partis des 200 premiers inscrits";
      }
    },
    openLink(link) {
      window.open(link, "_blank");
    }
  }
};
</script>
<style lang="scss">
.checkout {
  .input__error {
    font-size: 1.2rem;
    line-height: 1.3em;
    margin-bottom: 1rem;
    text-align: center;
  }
  &__content {
    padding: 5rem 3rem 3rem !important;
    @media #{$md-and-down} {
      padding: 1rem 0 0 !important;
    }
    h2 {
      margin-bottom: 3rem !important;
    }
  }
}
.formule {
  border: 1px solid get($colors, "grey");
  padding: 2rem 3rem;
  margin-bottom: 2rem;
  text-align: left;
  border-radius: get($radius, "arrounded");
  transition: all get($times, "fast");
  > div:nth-child(2) {
    justify-content: center;
    display: flex;
    flex-direction: column;
  }
  h3 {
    font-weight: bold;
    text-transform: uppercase;
    margin-bottom: 0.5em;
    transition: all get($times, "fast");
    font-size: 1.8rem;
    // color: get($theme, "secondary");
  }
  .input {
    width: 100%;
    text-transform: uppercase;
  }
  &__button {
    padding: 1rem;
    width: 100%;
    border: none;
  }
  &__price {
    text-align: center;
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 1rem;
    > span {
      font-size: 0.7em;
    }
  }
  &.--free {
    &:hover {
      border-color: get($theme, "secondary");
      h3 {
        color: get($theme, "secondary");
      }
    }
  }
  &.--lover {
    &:hover {
      border-color: get($theme, "primary");
      h3 {
        color: get($theme, "primary");
      }
    }
    .formule__button {
      background: get($theme, "primary");
      color: white;
    }
    .formule__price {
      color: get($theme, "primary");
    }
  }
  &.--addict {
    &:hover {
      border-color: get($theme, "secondary");
      h3 {
        color: get($theme, "secondary");
      }
    }
    .formule__button {
      background: get($theme, "primary");
      color: white;
    }
  }
  .formule__price {
    color: get($theme, "secondary");
  }

  &.--unavailable {
    display: none;
    background: get($theme, "border");
    border-color: get($colors, "grey") !important;
    cursor: not-allowed;
    * {
      cursor: not-allowed;
      color: get($colors, "grey") !important;
      border-color: get($colors, "grey") !important;
      &:hover {
        background: get($theme, "border") !important;
      }
    }
  }
}
// .popin-creditcard {
// position: fixed;
// z-index: 999;
// top: 0;
// left: 0;
// width: 100%;
// height: 100%;
// background: rgba(0, 0, 0, 0.2);
// }
</style>
